var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.subscriptionExtensionAttempt,"type":_vm.type}},[_vm._v("\n  "+_vm._s(_vm._f("trans")(_vm.messageKey))+" "),(_vm.displayEmail)?_c('a',{attrs:{"href":"mailto:kontakt@dietico.pl"}},[_vm._v("kontakt@dietico.pl")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }